import React from 'react';
import { Button, Col, message, Modal, Row, Steps ,Select} from 'antd';
import { Table } from "components/table";
import { Map, List } from 'immutable';
import { getDataFromQueryString } from "../../utils";
import { ONBOARDING_CASES_LIST_COLS } from "constants/table-columns";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { fetchCasesList, fetchCompanyAllMpa} from "actions";
import { STATE_STATUS } from "constants/state-status";
import { CompanyService, DBOnBoardingService, PaymentProgramService } from '../../services';
import CaseSelectionModal from '../../components/modals/case-selection-modal';

const Tabs = Map({
    docsPending: {
        label: "Docs Pending",
        key: 'docs_pending',
        id: 1,
    },
    mpaPendingCredit: {
        label: "MPA Pending - Credit",
        key: 'mpa_credit',
        id: 2,
    },
    mpaApprovalCCM: {
        label: "MPA Approval - CCM",
        key: 'mpa_ccm',
        id: 3,
    },
    agreement: {
        label: "Agreement",
        key: 'agreement',
        id: 4,
    },
    opsReview: {
        label: "Ops Review",
        key: 'ops_review',
        id: 5,
    },
    r2dReady: {
        label: "R2D Ready",
        key: 'r2d_completed',
        id: 6,
    },
    rejected: {
        label: "Rejected",
        key: 'rejected',
        id: 7,
    },
});


class AnchorOnboarding extends React.Component {
    state = {
        selectedTab: "docs_pending",
        currentPage: 1,
        showAssignModal : false,
        userAssignRemarks: "",
        selfAssign: "",
        selectedAgent: "",
        usersList : List(),
        dbCount  : Map(),
        viewCaseSelectionModal: false
    }
    pageSize = 20;

    componentDidMount() {
        DBOnBoardingService.fetchDbListCount({type: 1}).then(({ data }) => {
            this.setState({
                dbCount: Map(data)
            });
        });
        CompanyService.getUsersList("DB Onboarding").then(({ data }) => {
            this.setState({
                usersList: List(data)
            });
        });
        this.fetchCaseListing(getDataFromQueryString('stage'))
        this.setState({
            selectedTab: getDataFromQueryString('stage')
        });
    }

    componentDidUpdate(prevProps){
        if(this.props.allMpaDetails.get("status") == STATE_STATUS.FETCHED &&  prevProps.allMpaDetails.get("status") == STATE_STATUS.FETCHING){
            if(this.props.allMpaDetails.get("data").length >= 2){
                this.handleCaseSelectionModal()
            }else{
                const record = this.props.allMpaDetails.get("data")[0].get("mpa_approval");
                this.props.history.push(`/app/companies/${record.company.id}/?source=anchor-onboarding&stage=${record.action_detail.current_action_task.this_stage.id}&action_detail_id=${record.action_detail.id}&action_task_id=${record.action_detail.current_action_task.id}&mpa_id=${record.id}`)
            }
        }
    }

    fetchCaseListing(stage , filters = {}){
        if(stage === 'rejected'){ 
            filters = {status: 3}
        }
        this.props.fetchCasesList(stage , this.state.currentPage, this.pageSize, 1, filters);
    }


    onChangeTab = activeIndex => {
        const stage = Tabs.toList().find((_, index) => index == activeIndex);
        // console.log("inside tab change", getDataFromQueryString('stage'), stage);
        this.setState({
            selectedTab: stage.key,
            currentPage: 1,
        }, () => {
            this.props.history.replace(
                `/app/anchor-onboarding/?stage=${stage.key}`
            );
            this.forceUpdate();
            this.fetchCaseListing(getDataFromQueryString('stage'))
        });
    }

    onFilter = (_) => {
        this.fetchCaseListing(getDataFromQueryString('stage'), _)
    }

    selfAssignCase = (id) => {
        this.setState({
            selfAssign: id,
            showAssignModal: !this.state.showAssignModal,
            selectedAgent: "",
            userAssignRemarks: ""
        });
    }


    onPageChange = (page, pageSize) => {
        this.setState({
            currentPage: page
        }, () => {
            this.props.fetchDBOnBoardingList(getDataFromQueryString('stage') , page, pageSize, {});
        });
    }

    handleCaseClick = (record2) => {
        const record = record2.get("mpa_approval");
        this.props.history.push(`/app/companies/${record.company.id}/?source=anchor-onboarding&stage=${record2.getStageIDV2()}&action_detail_id=${record.action_detail.id}&mpa_id=${record.id}&action_task_id=${record.action_detail.current_action_task.id}`)
        // this.props.fetchCompanyAllMpa(companyId, record);
    }

    caseButton = (record) => {
        const caseId = record.id
        return <Button
            type="link"
            disabled={record.product_type == null}
            onClick={() => 
                this.props.fetchCompanyAllMpa(record.company.id, record)
            }>
            {caseId}
        </Button>
    }

    onBoardinTable = () => {
        // getCompanyAllMpa
        const {permissions} = this.props;
        return <Table
            columns={ONBOARDING_CASES_LIST_COLS(this.caseButton)}
            checkedColumns={[]}
            filterColumns={ONBOARDING_CASES_LIST_COLS().filter(_ => _.is_filter_applicable).map(_ => _.dataIndex).toList().toArray()}
            data={
                this.props.dbList.size ? this.props.dbList
                .map(_ => {
                    let row = _;
                    row.split = ([
                        this.state.selectedTab != "r2d_completed" ? permissions.size && permissions.get("page_dbonboarding_edit")&& <Button type={"link"} size={"small"} onClick={this.selfAssignCase.bind(null, _.get_action_task_id())}> {_.getAssignedUser() ? 'Re-assign' :  'Assign'}</Button> : <p>-</p>
                    ]);
                    return row;
                }) 
                .toList() : List()
            }
            showFooter={false}
            showPaginationOnly={false}
            bulkActionSelectedKey={"id"}
            customButtonTexts={["Assign"]}
            custonButtonIcons={[]}
            noRowSelection = {true}
            onFilter={this.onFilter}
            showTopSection={true}
            keyFilter={"id"}
            onCustomButtonClicks={[this.handleAssignCaseModal]}
            showColumnSelector={false}
            showHeader={true}
            pagination={{
                current: this.state.currentPage,
                showSizeChanger: true,
                defaultPageSize: 20,
                pageSizeOptions: [
                    "10",
                    "20",
                    "50",
                    "100",
                    "500"
                ],
                position: "bottom",
                total: this.props.dbListCount,
                onChange: (page, pageSize) =>
                    this.onPageChange(page, pageSize),
                onShowSizeChange: this.onPageSizeChange,
            }}
            loading={
                this.props.dbListFetchStatus !== STATE_STATUS.FETCHED &&
                this.props.dbListFetchStatus !== STATE_STATUS.UPDATED
            }
            editable={true}
            className={"inbox-table"}
        />
    }

    handleAssignCaseModal = () => {
        this.setState({
            showAssignModal: !this.state.showAssignModal,
            selectedAgent: "",
            userAssignRemarks: "",
            selfAssign: ""
        });
    }

    clearData = () => {
        this.setState({
            showAssignModal: !this.state.showAssignModal,
            selectedAgent: "",
            userAssignRemarks: "",
            selfAssign: ""
        });
    }

    assignCases = () => {
        const { userAssignRemarks, selfAssign ,selectedAgent} = this.state;
        if (selfAssign && userAssignRemarks.length) {
            DBOnBoardingService.assignCase(selfAssign, userAssignRemarks, selectedAgent ? selectedAgent : this.props.userDetails.id).then((response) => {
                if (response.status === 201) {
                    message.success("Case Assigned Successfully");
                    this.fetchCaseListing(getDataFromQueryString('stage'))
                }
                this.clearData();
            }).catch((err) => {
                this.clearData();
                if (err.non_field_errors) {
                    message.error(err.non_field_errors[0]);
                } else {
                    message.error("Something went wrong!");
                }
            });

        } else{
            message.error("Please fill the remarks")
        }
    }

    renderAssignCasesModal = () => {
        const { permissions } = this.props;
        return (
            <Modal
                title="Assign Cases"
                visible={this.state.showAssignModal}
                onOk={this.assignCases}
                onCancel={this.handleAssignCaseModal}
            >
                {permissions.size && permissions.get("page_db_onboarding_bulk_assign") &&
                    <>
                        <label>Select Agent</label>
                        <Select placeholder="Select Agent" className="mb-10 mt-5" value={this.state.selectedAgent || undefined} onChange={(_) => this.setState({ selectedAgent: _ })} style={{ width: "100%" }}>
                            {this.state.usersList.size && this.state.usersList.map((_, k) => (
                                <Option value={_.id} key={k}>{_.full_name}</Option>
                            ))}
                        </Select>
                    </>
                }
                <label style={{ marginTop: 15 }}>Remarks</label>
                <textarea
                    rows="4"
                    className="mt-5 w-100"
                    style={{
                        borderColor: "#d9d9d9"
                    }}
                    value={this.state.userAssignRemarks}
                    onChange={(_) => this.setState({ userAssignRemarks: _.target.value })}
                />
            </Modal>
        );
    }


    handleCaseSelectionModal = () => {
        this.setState({
            viewCaseSelectionModal: !this.state.viewCaseSelectionModal
        })
    }


    render() {
        console.log("companyis" , this.props.companyis);
        return (
            <Row>
                <Col span={24} className={"p-5"}>
                    <CaseSelectionModal
                        handleCaseClick={(_) => this.handleCaseClick(_)}
                        cases={this.props.allMpaDetails.get("data")}
                        handleCancel={() => this.handleCaseSelectionModal()}
                        handleOk={() => this.handleCaseSelectionModal()}
                        visible={this.state.viewCaseSelectionModal}
                    />
                    <Steps
                        className={"stage-tabs normal-steps-height"}
                        type={"navigation"}
                        size={"small"}
                        current={Tabs.toList().findIndex((_) => _.key == this.state.selectedTab)}
                        onChange={this.onChangeTab}
                        style={{
                            marginBottom: 10,
                            boxShadow: "0px -1px 0 0 #e8e8e8 inset",
                            overflowX: "scroll"
                        }}
                    >
                        {Tabs.map(_ => {
                            return (<Steps.Step
                                status={null}
                                key={_.id}
                                title={
                                    <div className="d-flex justify-content-space-between" style={{
                                        alignItems: "start",
                                        width: "100%"
                                    }}>
                                        <div>{_.label}<span>    ({this.state.dbCount.get(_.key.toLowerCase()) || 0})</span></div>
                                    </div>
                                }
                            />);
                        }).toList()}
                    </Steps>
                    {this.onBoardinTable()}
                    {this.renderAssignCasesModal()}
                </Col>
            </Row>
        )
    }
}

AnchorOnboarding.propTypes = {
    permissions: PropTypes.object,
    userDetails: PropTypes.object
};

const mapStateToProps = (state) => {
    return {
        dbList : List(state.onboardingData.get('casesList') , []),
        dbListFetchStatus : state.onboardingData.get('status'),
        permissions: state.user.get("permissions"),
        userDetails: state.user.get("data"),
        dbListCount :  state.dbOnBoarding.get('count' , 0),
        companyis: state.companies,
        allMpaDetails : state.companies.get("allMpaDetails")

    }
};

const mapDispatchToProps = dispatch =>
    bindActionCreators({
        fetchCasesList,
        fetchCompanyAllMpa
    }, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(AnchorOnboarding);
